module.exports = __webpack_public_path__ + "static/media/swimming.0cdeaf2d.mov";